export enum WebsiteBuilderView {
    index = 'index',
    documents = 'documents',
    announcements = 'announcements',
    buildingFeatures = 'amenityShowcase',
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/website-builder-view.ts